// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4850 ? "52774a7f" : chunkId) + "." + {"4850":"c2775dd8e19ad75c","9604":"a66d102e50ff6d15"}[chunkId] + ".js";
};